import React from 'react';
import { StatsCardProps } from '../types';

export function StatsCard({ title, value, subtitle, icon, gradient = 'gradient-primary', loading }: StatsCardProps) {
  if (loading) {
    return (
      <div className="glass-card p-6 rounded-xl animate-fade-in">
        <div className="flex items-center justify-between mb-4">
          <div className="loading-shimmer w-16 h-6 rounded"></div>
          <div className="loading-shimmer w-8 h-8 rounded-full"></div>
        </div>
        <div className="loading-shimmer w-20 h-8 rounded mb-2"></div>
        <div className="loading-shimmer w-24 h-4 rounded"></div>
      </div>
    );
  }

  return (
    <div className="glass-card p-6 rounded-xl hover:scale-105 transition-transform duration-300 animate-fade-in">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-400">{title}</h3>
        <div className={`p-2 rounded-lg ${gradient}`}>
          {icon}
        </div>
      </div>
      <div className="text-2xl font-bold text-white mb-1">{value}</div>
      {subtitle && <div className="text-sm text-gray-400">{subtitle}</div>}
    </div>
  );
}
